<script>
  import {createEventDispatcher} from 'svelte';
  import {fade, fly} from 'svelte/transition';

  export let visible = false;
  export let closeable = false;
  export let modalStyle = {};
  export let maskStyle = '';

  const dispatch = createEventDispatcher();

  let innerModalStyle = {};

  $: setTheme(visible);

  function setTheme(visible) {
    if (visible) {
      innerModalStyle = {...modalStyle, right: 0};
      maskStyle = 'background: rgba(0, 0, 0, 0.6)';
      return;
    }
    innerModalStyle = modalStyle;
    maskStyle = '';
  }

  function handleClose() {
    visible = false;
    dispatch('close');
  }

  function convertStyle(styleObj) {
    return Object.keys(styleObj).reduce((p, key) => p + `${key}: ${styleObj[key]};`, '');
  }

  function handleMaskClick() {
    handleClose();
  }
</script>

<style>
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    width: 100%;
    height: 100%;
    transition: all 0.3s ease-in;
  }
  .modal {
    position: absolute;
    right: -500px;
    padding: 40px;
    width: 480px;
    height: calc(100% - 80px);
    background: #fff;
    overflow: auto;
    transition: all 0.3s ease-in;
    box-sizing: inherit;
  }

  .close-btn {
    border-radius: 100%;
    width: 64px;
    height: 64px;
    background-color: var(--B4);
  }
  .iconfont {
    font-size: 32px;
  }

  @media screen and (max-width: 640px) {
    .modal {
      width: calc(100% - 80px);
      height: calc(100% - 32px) !important;
    }
    .close-btn {
      width: 32px;
      height: 32px;
    }
    .iconfont {
      font-size: 16px;
    }
  }
</style>

{#if visible}
  <div class="modal-mask" style={maskStyle} in:fade={{duration: 300}} out:fade={{duration: 300}} on:click={handleMaskClick}>
    <div class="modal sv" style={convertStyle(innerModalStyle)} transition:fly={{x: 500, duration: 500}} on:click={(e) => e.stopPropagation()}>
      <div class="df jcsb">
        <div class="f1">
          <slot name="header" />
        </div>
        {#if closeable}
          <div class="close-btn df aic jcc cp" on:click={handleClose}><i class="iconfont db T4">&#xe614;</i></div>
        {/if}
      </div>
      <slot />
    </div>
  </div>
{/if}
